import React, { useState } from 'react'
import { makeStyles, Icon, Popper, Box } from '@material-ui/core'
import * as colors from '../../utils/colors'

const useStyles = (variant) => {
	const color = colors[variant] || 'purple'
	const style = {
		background: color[500]
	}
	if (variant === 'gray') {
		style.background = color[800]
	}
	if (variant === 'dangers') {
		style.background = color[500]
	}
	if (variant === 'warnings') {
		style.background = color[500]
	}
	if (variant === 'successes') {
		style.background = color[500]
	}
	if (variant === 'errors') {
		style.background = color[500]
	}

	return makeStyles(() => ({
		root: {
			width: '1.1rem',
			height: '1.1rem',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center'
		},
		icon: { color: style.background, fontSize: '0.8rem', overflow: 'unset' },
		iconContainer: { marginTop: '-1px' },
		cursor: { cursor: 'pointer' },
		indicatorCircle: { color: style.background, fontSize: '0.5625rem', overflow: 'unset' },
		tooltipChildrenContainer: {
			display: 'flex',
			maxWidth: '15.5rem',
			gap: '1rem',
			fontFamily: 'Nunito',
			fontSize: '.875rem',
			color: colors.gray[900],
			'& a': {
				color: colors.gray[900]
			},
			'& p': {
				margin: 0,
				marginBottom: '.5rem'
			}
		}
	}))
}

/**
 * An icon with associated tooltip. Tooltip content can be jsx or a string. skiptown variant controls icon color and circular indicator inside text
 * @param {{tooltipChildren?: JSX.Element, tooltipText?: string, faIcon?: string, skiptownvariant?: 'gray' | 'purple'| 'dangers'| 'warnings'| 'successes'| 'errors'}} props
 * @returns
 */
const StyledIconWithTooltip = ({
	tooltipChildren = null,
	tooltipText = '',
	faIcon = 'fa-info-circle',
	skiptownvariant = 'purple',
	placement = 'right-start'
}) => {

	const classes = useStyles(skiptownvariant)()
	const [anchorEl, setAnchorEl] = useState(null)

	const handleClick = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget)
	}

	const open = Boolean(anchorEl)
	const icon = open ? 'fa-times-circle' : faIcon
	const id = open ? 'icon-with-tooltip' : undefined

	return (
		<div className={classes.iconContainer}>
			<Icon
				className={`fas ${icon} ${classes.icon} ${classes.cursor}`}
				onClick={(e) => {
					handleClick(e)
				}}
			/>
			<Popper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement={placement}
				style={{ zIndex: 10000, paddingLeft: '.5rem' }}>
				<Box
					sx={{
						border: 1,
						padding: '1rem',
						bgcolor: 'background.paper',
						borderRadius: 6,
						boxShadow: '0px 0px 15px 0px rgba(26, 26, 53, .2)'
					}}>
					<div className={classes.tooltipChildrenContainer}>
						<div>
							<Icon className={`fas fa-circle ${classes.indicatorCircle}`} />
						</div>
						{tooltipChildren ? <div>{tooltipChildren}</div> : null}
						{!tooltipChildren && tooltipText > '' ? <div>{tooltipText}</div> : null}
					</div>
				</Box>
			</Popper>
		</div>
	)
}

export default StyledIconWithTooltip
